/**
 * Admin console — copy for the super-admin surfaces under /admin.
 *
 * Its own slice rather than more lines in en.ts: that file is a merge hotspot
 * already at the 500-line ceiling. Composed into `en` in ./en.ts.
 *
 * The BusinessType labels mirror the server enum (prisma/schema/workspace.prisma:
 * ecommerce | service | course | saas | coaching | content_creator). They are
 * explicit keys rather than a prettified enum value so the wording stays
 * translatable and survives a rename on the server side.
 */
export const enAdmin = {
  'admin.tenants.businessType': 'Business Type',
  'admin.businessType.ecommerce': 'E-commerce',
  'admin.businessType.service': 'Service',
  'admin.businessType.course': 'Course',
  'admin.businessType.saas': 'SaaS',
  'admin.businessType.coaching': 'Coaching',
  'admin.businessType.content_creator': 'Content Creator',
  'admin.businessType.unknown': 'Unknown',
} as const;

export default enAdmin;
